﻿import { Status } from "../../API/LiveData/LiveDataSet";
import { IStationValueFormatter, IStationValueObject, WarningThreshold } from "../../Formatters/IStationValueFormatter";
import { MainSite } from "../../MainSite";
import { Station } from "../../Model/Station";
import { PopupChartable } from "../../PopupChartable";

export class TableCell extends PopupChartable {
    constructor(public mainSite: MainSite, container: JQuery, valueFormatter: IStationValueFormatter, station: Station, valueObject: IStationValueObject, openPopups: string[]) {
        super(mainSite);

        this.station = station;
        this.valueFormatter = valueFormatter;

        this.setSensor(this.valueFormatter.getSensorId() ?? valueObject.Sensor);
        this.setTimestamp(valueObject.Timestamp);
        
        var cell = $('<td></td>')
            .appendTo(container)
            .attr('title', 'Timestamp: ' + moment(moment.utc(valueObject.Timestamp)).tz(this.mainSite.selectedRegion.TimeZone).format("YYYY-MM-DD HH:mm") + '. Click for parameter popup.')
            .click((e: JQueryMouseEventObject) => {
            this.renderPopup(e, openPopups);
        });

        cell.text(valueObject.Value);

        if (valueObject.Status === null || valueObject.Status == Status.Expired) {
            cell.css('font-size', '0.8em');
        }

        if (valueObject.Status !== Status.Good) {
            cell.addClass('midi_siteObsPage_expiring');
        }

        if (valueObject.WarningThreshold == WarningThreshold.Level3) {
            cell.addClass('midi_siteObsPage_exceeded_threshold_3');
        } else if (valueObject.WarningThreshold == WarningThreshold.Level2) {
            cell.addClass('midi_siteObsPage_exceeded_threshold_2');
        } else if (valueObject.WarningThreshold == WarningThreshold.Level1) {
            cell.addClass('midi_siteObsPage_exceeded_threshold_1');
        }
    }
}